// Brand config (white-label) — đọc HOÀN TOÀN từ runtime config /config.js (window.__ENV__),
// mount volume theo từng deployment. Ảnh logo/favicon cũng mount file + trỏ URL trong config.js.
// KHÔNG gọi BE. Thiếu giá trị -> fallback default Intellix Pro / logo mặc định.

const RT = () => (typeof window !== 'undefined' && window.__ENV__) || {};
const viteEnv = () => import.meta.env;

export interface BrandConfig {
  app_name: string;
  copyright: string;
  primary_color: string;
  has_logo: boolean;
  has_favicon: boolean;
}

/** Mặc định khi config.js để trống. Xanh công nghệ #0A78A8, đủ tương phản chữ trắng. */
export const BRAND_DEFAULTS = {
  app_name: 'GANET',
  copyright: 'Intellix Pro Tech Solutions',
  primary_color: '#0A78A8',
};

export const getBrand = (): BrandConfig => {
  const rt = RT();
  const env = viteEnv();
  return {
    app_name: rt.APP_NAME || env.VITE_APP_NAME || BRAND_DEFAULTS.app_name,
    copyright: rt.COPYRIGHT || env.VITE_APP_COPYRIGHT || BRAND_DEFAULTS.copyright,
    primary_color: rt.PRIMARY_COLOR || env.VITE_PRIMARY_COLOR || BRAND_DEFAULTS.primary_color,
    has_logo: !!(rt.LOGO_URL || env.VITE_LOGO_URL),
    has_favicon: !!(rt.FAVICON_URL || env.VITE_FAVICON_URL),
  };
};

/**
 * Bản Intell không có trụ sở Cơ quan chủ quản trên bản đồ như KVS.
 * false: ẩn thẻ logo góc phải, marker và panel thông tin. Bật true khi cần hiện lại.
 */
export const showManagingOrg: boolean = false;

/** URL logo/favicon = file mount (trỏ trong config.js). Rỗng -> dùng logo/favicon mặc định. */
export const brandLogoUrl = (): string => RT().LOGO_URL || import.meta.env.VITE_LOGO_URL || '';
export const brandFaviconUrl = (): string => RT().FAVICON_URL || import.meta.env.VITE_FAVICON_URL || '';

/** Áp brand vào document (title + favicon). Gọi 1 lần lúc bootstrap (đồng bộ, không fetch). */
export function applyBrand(): void {
  const b = getBrand();
  document.title = b.app_name;
  if (b.has_favicon) {
    let link = document.querySelector<HTMLLinkElement>("link[rel~='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    link.href = brandFaviconUrl();
  }
}
